import React, { useState, useEffect } from 'react';
import SignUp from 'pages/Signup/Signup';
import * as Styled from '../Layout.styled';

const UserAccessRightsLayout: React.FC = () => {
  return <SignUp />;
};

export default UserAccessRightsLayout;
